import { createPlacement } from '@post-office/placement-common-v2';
import { type EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';
import { usePlacementApi } from '@post-office/use-placement-api';

import type { MessageTemplateContext } from './test-messages/test-message';
import { useEffect, useState } from 'react';

export const { createFrontend, createBackend } = createPlacement({
	placementId: 'share-and-permissions-modal',
	options: {
		choreographer: {
			isDefaultEnabled: true,
		},
		hideInIsolatedCloud: false,
	},
});

export const PlacementFrontend = createFrontend((Messages) => () => {
	const [message, setMessage] = useState<EligibleMessage<MessageTemplateContext>>();
	const { data, error, isLoading } = usePlacementApi<{
		messages: Array<EligibleMessage<MessageTemplateContext>>;
	}>('/');

	useEffect(() => {
		setMessage(data?.messages[0]);
	}, [data?.messages]);

	const handleDismiss = () => {
		setMessage(undefined);
	};

	if (error) {
		throw error;
	}

	if (isLoading || !message) {
		return null;
	}

	return <Messages.render {...message} onDismiss={handleDismiss} />;
});

export const PlacementBackend = createBackend();
